import React, { useEffect, useState } from "react";

import { avatarGradient, initialsFor } from "../../utils/avatarColors";

/**
 * Round avatar with the same fallback the apps use: initials on a gradient
 * picked from the name. Also falls back when the photo fails to load (some
 * avatar URLs are behind auth and 403 for anonymous visitors), so the page
 * never shows a broken image.
 */
function Avatar({ src, name, colorSeed, initials, className = "" }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const showPhoto = Boolean(src) && !failed;
  const [top, bottom] = avatarGradient(colorSeed ?? name);
  const style = { "--vp-avatar-top": top, "--vp-avatar-bottom": bottom };

  return (
    <div className={`vp-avatar ${className}`.trim()} style={style}>
      {showPhoto ? (
        <img src={src} alt="" onError={() => setFailed(true)} />
      ) : (
        <span className="vp-avatar-initials" aria-hidden="true">
          {initials ?? initialsFor(name)}
        </span>
      )}
    </div>
  );
}

export default Avatar;
